import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import Logo from '../components/Logo';
import BuyerAgreementWizard from '../components/BuyerAgreementWizard';
import './ContractDetail.css';
import './BuyerAgreementDetail.css';
import { getBackendBaseUrl } from '../utils/apiUrls';

const BASE_URL = getBackendBaseUrl();


const BuyerAgreementCreate = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth0();

  const handleSubmit = async (payload) => {
    const res = await axios.post(`${BASE_URL}/buyer-agreements/`, {
      user_email: user?.email,
      ...payload,
    });
    return res.data;
  };

  const handleSuccess = (result) => {
    const newId = result?.id || result?.buyer_agreement_id;
    if (newId) navigate(`/buyer-agreement/${newId}`);
    else navigate('/');
  };

  if (!isAuthenticated) return null;

  return (
    <div className="contract-detail-container">
      <header className="app-header">
        <div className="header-content">
          <div className="header-left">
            <Logo size={40} />
            <div className="header-title-section">
              <h1 className="property-address-title ba-title-gold">New Buyer Agreement</h1>
            </div>
          </div>
          <div className="header-right">
            <button className="back-button" type="button" onClick={() => navigate('/')}>← Back</button>
          </div>
        </div>
      </header>

      <main className="main-content">
        <div style={{ maxWidth: 640 }}>
          <BuyerAgreementWizard
            mode="embedded"
            isOpen
            userEmail={user?.email}
            portalOnSubmit={handleSubmit}
            onSuccess={handleSuccess}
            onClose={() => navigate('/')}
            submitLabel="Create Buyer Agreement"
          />
        </div>
      </main>
    </div>
  );
};

export default BuyerAgreementCreate;
